import { deleteObject, getDownloadURL, ref, uploadBytes } from 'firebase/storage';
import { v4 as uuidv4 } from 'uuid';

import { taskApi } from 'api';
import { MyRef, myStorage } from 'Common/Firebase';

async function addImg(
  file: File,
  currentICLId: string,
  taskId: string,
  photoArr: string[],
  destination: 'taskPhotos' | 'answersPhotos' | 'editedAnswerPhotos',
) {
  const newId = uuidv4();
  const fileNameWithId = `id-${newId}-${file.name}`;

  const storageRef = MyRef(myStorage, 'Images/' + fileNameWithId);

  const snapshot = await uploadBytes(storageRef, file);
  const imgUrl = await getDownloadURL(snapshot.ref);
  let imgArr;

  if (!photoArr) {
    imgArr = [imgUrl];
  } else {
    imgArr = [...photoArr, imgUrl];
  }

  await taskApi.updateTask(currentICLId, { id: taskId, [destination]: imgArr });

  return imgArr;
}

async function addImgArray(
  files: string[],
  currentICLId: string,
  taskId: string,
  destination: 'taskPhotos' | 'answersPhotos' | 'editedAnswerPhotos',
) {
  await taskApi.updateTask(currentICLId, { id: taskId, [destination]: files });

  return files;
}

async function removeImg(
  imgUrl: string,
  currentICLId: string,
  taskId: string,
  photoArr: string[],
  destination: 'taskPhotos' | 'answersPhotos' | 'editedAnswerPhotos',
) {
  const fileRef = ref(myStorage, imgUrl);

  await deleteObject(fileRef);

  const imgArr = photoArr.filter(photo => photo !== imgUrl);

  await taskApi.updateTask(currentICLId, { id: taskId, [destination]: imgArr });

  return imgArr;
}

export const imgApi = {
  addImg,
  addImgArray,
  removeImg,
};
